// extracted by mini-css-extract-plugin
module.exports = {"container":"xxlDeckLoaderModal_container__NpNL9","loadCards":"xxlDeckLoaderModal_loadCards__cYPYN"};